module.exports = __webpack_public_path__ + "static/media/kelvi_response_guide.6fc398c6.pdf";